import { createContext } from 'react';
import { ToastProps } from '../Toast.types';

type ToastContext = {
  toastProps: ToastProps | null;
  toggleToast: (toastProps: ToastProps | null) => void;
};

export const ToastContext = createContext<ToastContext | undefined>(undefined);
